import { render, staticRenderFns } from "./PerfilMaster.vue?vue&type=template&id=3a1f1cff&"
import script from "./PerfilMaster.vue?vue&type=script&lang=js&"
export * from "./PerfilMaster.vue?vue&type=script&lang=js&"
import style0 from "./PerfilMaster.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports